module.exports = __webpack_public_path__ + "static/media/braille.bedaf12d.svg";